import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const INVALID_CHARS = /[/\\:*?"<>|]/;
const MAX_LENGTH = 255;

function validate(name, siblings = []) {
  const trimmed = (name || "").trim();
  if (!trimmed) return "El nombre es requerido";
  if (trimmed.length > MAX_LENGTH) return `Máximo ${MAX_LENGTH} caracteres`;
  if (INVALID_CHARS.test(trimmed)) return 'No se permiten estos caracteres: / \\ : * ? " < > |';
  const exists = siblings.some((s) => (s.name || "").toLowerCase() === trimmed.toLowerCase());
  if (exists) return "Ya existe una carpeta con ese nombre en este nivel";
  return null;
}

export function CreateFolderModal({ open, onClose, onConfirm, siblings = [], busy = false }) {
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
      setError(null);
      setTouched(false);
    }
  }, [open]);

  const onChange = (e) => {
    setName(e.target.value);
    if (touched) setError(validate(e.target.value, siblings));
  };

  const onBlur = () => {
    setTouched(true);
    setError(validate(name, siblings));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const err = validate(name, siblings);
    setTouched(true);
    setError(err);
    if (err) return;
    await onConfirm(name.trim());
  };

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <form onSubmit={onSubmit}>
        <DialogTitle>Nueva carpeta</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="Nombre de la carpeta"
            value={name}
            onChange={onChange}
            onBlur={onBlur}
            error={!!error}
            helperText={error || `${name.length}/${MAX_LENGTH}`}
            disabled={busy}
            inputProps={{ maxLength: MAX_LENGTH }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={busy}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={busy || !!error}>
            {busy ? "Creando..." : "Crear"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
